import Immutable from "immutable";

const createStore =
    (handlers, initialState = Immutable.Map()) =>
    (state = initialState, action) =>
        handlers[action.type]
            ? handlers[action.type](state, action)
            : action.type === "LOGOUT_USER"
              ? initialState
              : state;
export default createStore;
